import { render, staticRenderFns } from "./PTI.vue?vue&type=template&id=1d8b3768&"
import script from "./PTI.vue?vue&type=script&lang=js&"
export * from "./PTI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports